module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert error tiny reveal",
    attrs: {
      "id": _vm.domUid,
      "role": "error-information"
    }
  }, [_c('p', [_vm._v("Hiba: " + _vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4fdada7d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/Reveal.vue
// module id = 476
// module chunks = 2